import React from 'react';
import { getCurrentTenantId } from '../core/services/firebase/firestore';

export const DevModeSwitcher: React.FC = () => {
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return null;
  }

  const currentTenant = getCurrentTenantId();

  const setMode = (mode: string) => {
    if (mode === 'clear') {
        localStorage.removeItem('dev_tenant_id');
    } else {
        localStorage.setItem('dev_tenant_id', mode);
    }
    window.location.href = '/';
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-gray-800 text-white p-4 rounded-lg shadow-xl text-xs opacity-75 hover:opacity-100 transition-opacity">
      <div className="font-bold mb-2 text-yellow-400">🔧 Dev Mode Switcher</div>
      <div className="mb-2">Current: <span className="font-mono bg-gray-700 px-1 rounded">{currentTenant}</span></div>
      <div className="flex flex-col gap-2">
        <button onClick={() => setMode('platform')} className="bg-blue-600 px-2 py-1 rounded hover:bg-blue-500">
          Go to Platform
        </button>
        <button onClick={() => setMode('builder')} className="bg-purple-600 px-2 py-1 rounded hover:bg-purple-500">
          Go to Builder
        </button>
        <button onClick={() => setMode('demo')} className="bg-green-600 px-2 py-1 rounded hover:bg-green-500">
          Go to Demo Tenant
        </button>
        <button 
          onClick={() => {
            const current = localStorage.getItem('devMode') === 'true';
            localStorage.setItem('devMode', (!current).toString());
            window.location.reload();
          }} 
          className="bg-yellow-600 px-2 py-1 rounded hover:bg-yellow-500 font-bold"
        >
          {localStorage.getItem('devMode') === 'true' ? 'Disable Admin Bypass' : 'Enable Admin Bypass'}
        </button>
        <button onClick={() => setMode('clear')} className="bg-red-600 px-2 py-1 rounded hover:bg-red-500">
          Reset (Default)
        </button>
      </div>
    </div>
  );
};
